export const APPLICANT_PROFILE_WIDGET_KEY = {
  stageScreening: 'stage-screening',
}

// TODO: the attention and matched-listing widgets come with their backend reads
export const APPLICANT_PROFILE_WIDGET_LIST_ORDER = [
  APPLICANT_PROFILE_WIDGET_KEY.stageScreening,
]
